import { isNumber } from "lodash";

import { DateFns, ConstantFormat } from "../../../../../utils/DateFns";

interface FormatDateParams {
	date: string | number | Date;
	isTitleFormat?: boolean;
	isTimeFormat?: boolean;
	isDayFormat?: boolean;
}

const formatDate = ({
	date,
	isTitleFormat = false,
	isTimeFormat = false,
	isDayFormat = false,
}: FormatDateParams): string => {
	const dateFns = new DateFns();

	let format: DateFns.ValueFormat;
	switch (true) {
		case isTitleFormat:
			format = ConstantFormat.MDY_UK;
			break;
		case isTimeFormat:
			format = ConstantFormat.HM_UK;
			break;
		case isDayFormat:
			format = ConstantFormat.MDY_UK;
			break;
		default:
			format = ConstantFormat.MDYHM_UK;
	}

	return dateFns.formatTime2(date, format);
};

const formatDistance = (distance: number): string => {
	const value = isNumber(distance) ? distance : 0;

	const retval = (value / 1000).toFixed(3);
	return retval;
};

const formatMoney = (money: number): string => {
	const value = isNumber(money) ? money : 0;

	const retval = value.toFixed(2);
	return retval;
};

const formatTimeToMinutes = (milliseconds: number): number => {
	if (!isNumber(milliseconds) || milliseconds < 0) {
		return 0;
	}

	const seconds = Math.abs(milliseconds) / 1000;
	const minutes = Math.floor(seconds / 60);
	return minutes;
};

/** Excel keeps dates as UTC serials: shift so the cell shows local time like the table */
const toExcelLocalDate = (value: unknown): Date | null => {
	if (!value) return null;
	const date = new Date(value as string);
	if (Number.isNaN(date.getTime())) return null;
	return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
};

export {
	formatDate,
	formatDistance,
	formatMoney,
	formatTimeToMinutes,
	toExcelLocalDate,
};
